import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'ag-overdrive-magazine-dialog',
  templateUrl: './overdrive-magazine-dialog.component.html',
  styleUrls: ['./overdrive-magazine-dialog.component.scss'],
})
export class OverdriveMagazineDialogComponent implements OnInit {
  selectItemControl = new FormControl();
  constructor(
    public dialogRef: MatDialogRef<OverdriveMagazineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.selectItemControl.setValue([
      this.data.magazineIssues.find(
        (magazine) => magazine.edition === this.data.selectedMagazineEdition,
      ),
    ]);
  }

  closeDialog(magazine) {
    this.dialogRef.close(magazine);
  }
}
